var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeoForm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.21597L1.0744 7.71169C1.0744 7.71169 2.41743 6.5679 2.90092 6.5679C3.20125 6.5679 3.84104 6.94919 4.24395 8.26887C4.64687 9.58862 6.34332 16.4296 6.44651 16.7445C6.9102 18.1594 7.52091 20.7916 9.4012 21.1729C11.2815 21.5542 13.672 19.4719 14.9882 17.9469C16.3043 16.4219 21.4885 9.9112 21.7033 6.01066C21.902 2.40408 20.8184 1.56724 20.3334 1.23028C19.447 0.614401 17.9697 0.409151 16.573 0.936983C15.1762 1.46482 13.0543 3.1952 12.4902 6.27454C12.4902 6.27454 14.3973 5.51204 15.0956 6.24519C15.794 6.97834 15.606 8.59138 15.0151 9.7938C14.4241 10.9962 12.7588 13.7823 12.141 13.8703C11.5232 13.9583 11.0397 12.6385 10.9591 12.2866C10.8785 11.9347 9.85782 7.09567 9.48178 4.28028C9.10575 1.46488 7.46727 0.995617 6.68826 0.995617C5.90931 0.995683 4.56629 1.64092 0 6.21597Z",
    fill: "#4D9EF6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeoForm);
export default __webpack_public_path__ + "static/media/vimeo-form.725d56c04fe244905afbd5311c05fad5.svg";
export { ForwardRef as ReactComponent };